// URL API из переменных окружения
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TELEGRAM_BOT_USERNAME = process.env.REACT_APP_TELEGRAM_BOT_USERNAME;


export const TELEGRAM_URL = 'https://t.me';